import React from 'react';
import { useLanguage } from '../LanguageContext';
import { motion } from 'framer-motion';
import { XCircle, CheckCircle2, TrendingUp, AlertCircle } from 'lucide-react';
export const PainPoints = () => {
  const {
    t
  } = useLanguage();
  return <section className="py-24 bg-white" data-id="element-116">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-117">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-118">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4" data-id="element-119">
            {t.painPoints.title}
          </h2>
          <p className="text-lg text-slate-600" data-id="element-120">{t.painPoints.subtitle}</p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-121">
          {/* Unstructured / Bad Way */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-red-50 rounded-3xl p-6 sm:p-8 border border-red-100 relative overflow-hidden" data-id="element-122">
            <div className="absolute top-0 right-0 w-32 h-32 bg-red-100 rounded-bl-full -mr-16 -mt-16 opacity-50" data-id="element-123"></div>
            <div className="w-14 h-14 bg-red-100 rounded-2xl flex items-center justify-center mb-6 text-red-600" data-id="element-124">
              <XCircle size={32} data-id="element-125" />
            </div>
            <h3 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-126">
              {t.painPoints.unstructured.title}
            </h3>
            <p className="text-slate-600 leading-relaxed mb-6" data-id="element-127">
              {t.painPoints.unstructured.desc}
            </p>
            <div className="flex items-center gap-3 text-red-700 font-medium bg-red-100/50 p-4 rounded-xl" data-id="element-128">
              <AlertCircle size={20} data-id="element-129" />
              <span data-id="element-130">Result: Stuck on a plateau</span>
            </div>
          </motion.div>

          {/* Structured / Good Way */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="bg-indigo-50 rounded-3xl p-6 sm:p-8 border border-indigo-100 relative overflow-hidden shadow-lg shadow-indigo-100/50" data-id="element-131">
            <div className="absolute top-0 right-0 w-32 h-32 bg-indigo-100 rounded-bl-full -mr-16 -mt-16 opacity-50" data-id="element-132"></div>
            <div className="w-14 h-14 bg-indigo-600 rounded-2xl flex items-center justify-center mb-6 text-white shadow-md" data-id="element-133">
              <CheckCircle2 size={32} data-id="element-134" />
            </div>
            <h3 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-135">
              {t.painPoints.structured.title}
            </h3>
            <p className="text-slate-600 leading-relaxed mb-6" data-id="element-136">
              {t.painPoints.structured.desc}
            </p>
            <div className="flex items-center gap-3 text-indigo-700 font-medium bg-indigo-100/50 p-4 rounded-xl" data-id="element-137">
              <TrendingUp size={20} data-id="element-138" />
              <span data-id="element-139">Result: Massive improvement in weeks</span>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
};